import Modal from './_bootstrapModalExtensions';
import Interfaces from './_interfaces';
import Classes from './_classes';
import NotificationUtil from './_notificationUtil';

export function OnChamberMembershipAddButtonClicked(event: JQuery.ClickEvent) {
    event.preventDefault();

    const getChamberMembershipTemplateUrl: string = window.ETDR_RD.appConfig['UrlAction.GetChamberMembershipTemplate'];
    const addChamberMembershipUrl: string = window.ETDR_RD.appConfig['UrlAction.AddChamberMembership'];

    const chamberMembershipSettings: Classes.BootstrapModalWithAjaxContentSettings = GetChamberMembershipSettings();

    Modal.showBootstrapModalWithAjaxContent(chamberMembershipSettings);

    function GetChamberMembershipSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Kamarai tagság hozzáadása';
        settings.contentUrl = getChamberMembershipTemplateUrl;
        settings.saveUrl = addChamberMembershipUrl;
        settings.callback = () => RefreshCurrentChamberMemberships();

        return settings;
    }
}

export function OnChamberMembershipDeleteButtonClicked(event: JQuery.ClickEvent) {
    const deletionUrl: string = $(event.currentTarget).data('href');
    const membershipId: string = $(event.currentTarget).data('membership-id');

    const onAccept: Modal.ConfirmWindowCallback = () => {
        $.ajax({
            method: 'POST',
            url: deletionUrl,
            data: {
                'id': membershipId
            },
            headers: { Accept: 'application/json' }
        })
            .done((response: Interfaces.BaseJsonResponse) => {
                if (response.success) {
                    RefreshCurrentChamberMemberships();
                } else {
                    NotificationUtil.Error(response.message);
                }
            });
    };

    Modal.showConfirmationWindowAsync(
        'Biztosan törölni szeretné a kamarai tagságot?',
        'Kamarai jogosultság törlése',
        onAccept,
        () => { },
        'Törlés',
        'Mégse')
}

export function RefreshCurrentChamberMemberships() {
    let listChamberMembershipsForCurrentUserUrl: string = window.ETDR_RD.appConfig['UrlAction.ListChamberMembershipsForCurrentUser'];

    $('#kamara-list').load(listChamberMembershipsForCurrentUserUrl, () => {

        let $btn: JQuery = $('#kamara-tagsag-add-button');
        let $statement: JQuery = $('#' + $btn.data('statement-field-id'));
        let $designer: JQuery = $('#' + $btn.data('designer-field-id'));

        if ($('#kamara-list').children('.kamara-tagsag-row').length === 0) {
            $statement.prop('checked', false);
            $designer.prop('checked', false);
        }
    });
}

jQuery(() => {
    $(document).on('click', '#kamara-tagsag-add-button', (event: JQuery.ClickEvent) => {
        OnChamberMembershipAddButtonClicked(event);
    });

    $(document).on('click', '#chamber-membership-delete-btn', (event: JQuery.ClickEvent) => {
        OnChamberMembershipDeleteButtonClicked(event);
    });
});
